import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.00065 2C7.74728 2 7.49345 2.0849 7.28522 2.25363C6.60438 2.80533 5.99371 3.43916 5.46732 4.14102C5.30857 4.35269 5.29001 4.63821 5.42004 4.86865C5.55007 5.09908 5.80406 5.23081 6.06732 5.20435C6.27267 5.18371 6.46803 5.16086 6.65694 5.13876C6.89022 5.11147 7.11372 5.08532 7.33398 5.06593V10C7.33398 10.3682 7.63246 10.6667 8.00065 10.6667C8.36884 10.6667 8.66732 10.3682 8.66732 10V5.06593C8.88758 5.08532 9.11103 5.11146 9.34432 5.13875C9.53321 5.16085 9.72865 5.18371 9.93398 5.20435C10.1972 5.23081 10.4512 5.09908 10.5813 4.86865C10.7113 4.63821 10.6927 4.35269 10.534 4.14102C10.0076 3.43916 9.39692 2.80533 8.71608 2.25363C8.50785 2.08491 8.25403 2 8.00065 2Z",
		fill: "#9333EA"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.66732 10C2.66732 9.63181 2.36884 9.33333 2.00065 9.33333C1.63246 9.33333 1.33398 9.63181 1.33398 10C1.33398 12.2091 3.12485 14 5.33398 14H10.6673C12.8765 14 14.6673 12.2091 14.6673 10C14.6673 9.63181 14.3688 9.33333 14.0007 9.33333C13.6325 9.33333 13.334 9.63181 13.334 10C13.334 11.4728 12.1401 12.6667 10.6673 12.6667H5.33398C3.86123 12.6667 2.66732 11.4728 2.66732 10Z",
		fill: "#9333EA"
	})]
});
const ForwardRef = forwardRef(SvgUploadUp);
export default ForwardRef;
